<template>
  <div
    class="flex flex-col h-fit bg-light-grey rounded-xl p-4 overflow-hidden shadow-lg border border-gray-100"
  >
    <div class="flex justify-between">
      <p class="text-primary-900 text-lg">
        {{ $t("calls.caller_profile") }}
      </p>
      <div class="flex gap-2">
        <Button
          :disabled="loading"
          rounded
          class="bg-white text-sm p-2 rounded-full !text-primary-500 shadow-md hover:!bg-primary-900 hover:!text-white"
          @click="hasCallerInfo ? View() : Create()"
          ><v-icon>{{
            hasCallerInfo ? "mdi-pencil" : "mdi-plus"
          }}</v-icon></Button
        >
        <Button
          :disabled="loading"
          rounded
          class="bg-white text-sm p-2 rounded-full !text-primary-500 shadow-md hover:!bg-primary-900 hover:!text-white"
          @click="Refresh()"
          ><v-icon>mdi-refresh</v-icon></Button
        >
      </div>
    </div>
    <div v-if="loading" class="flex items-center gap-2 mx-4">
      <Skeleton class="!rounded-full !w-16 !h-16" />
      <div class="flex flex-col gap-1 w-6/12">
        <Skeleton class="!w-full !h-4" />
        <Skeleton class="!w-7/12 !h-4" />
      </div>
    </div>
    <div v-else-if="hasCallerInfo" class="flex items-center gap-2 mx-4">
      <img :src="require('@/assets/user.png')" alt="logo" class="w-16 h-16" />
      <div class="flex flex-col gap-1">
        <p class="text-primary-900">{{ callerInfo["الاسم"] }}</p>
        <p class="text-primary-900 text-xs">{{ callerInfo["المنطقة"] }}</p>
        <p class="text-primary-900 text-xs">{{ callerInfo["رقم الهاتف"] }}</p>
      </div>
    </div>
    <div v-else class="flex items-center justify-center p-5 mx-4">
      <p class="text-primary-900">{{ $t("calls.caller_info.no_caller_info") }}</p>
    </div>
  </div>
</template>
<script>
import moment from "moment";
import { mapActions, mapGetters, mapMutations } from "vuex";
import { Button, Skeleton } from "primevue";

export default {
  props: {
    senderId: {
      type: String,
      required: false,
    },
  },
  components: {
    Button,
    Skeleton,
  },
  data() {
    return {
      customer: "",
      callerInfo: {
        // "اسم المستفيد": "محمد سليمان أحمد",
        // منطقة: "الرياض",
        // "نوع المستفيد": "شخص",
        // "رقم الجوال": "0123456789",
        // "رقم الطلب": "129012",
        // "عنوان التذكرة": "إستسفسار عن التراخيص",
        // "نوع الطلب": "مشكلة",
        // الفرع: "الرئيسي",
        // "حالة الطلب": "مسؤول الصحة النباتية",
        // "تاريخ الانشاء": "2024-05-11 09:10:33",
        // "تاريخ اخر تحديث": "2024-05-23 13:25:44",
      },
      hasCallerInfo: false,
      loading: false,
      inInfoMode: false,
      createLocalLoading: false,
      showSnackbar: false,
      errorMsg: "",
    };
  },
  computed: {
    ...mapGetters([
      "CRMInitInfo",
      "currentCall",
      "crmLocalFields",
      "acwSettings",
      "acwStatus",
      "acwCRM",
      "inCall",
    ]),
    localizedCallerNumber() {
      // console.log("my number", this.currentCall?.SourceID);
      return this.$t("home.caller_info.title", {
        caller: this.currentCall?.SourceID,
      });
      // return this.$t("home.caller_info.title", {
      //   caller:
      //     // this.$n(0, "mainNum", "ar-EG") +
      //     this.$n(parseInt(this.currentCall?.SourceID, 10), "mainNum", "ar-EG"),
      // });
    },
    disableCreateBtn() {
      return (
        (this.CRMInitInfo.has_info_create || this.CRMInitInfo.is_local) &&
        (!this.crmLocalFields || this.crmLocalFields?.length == 0)
      );
    },
    currentLocal() {
      return this.$vuetify.locale.current;
    },
  },
  methods: {
    ...mapActions(["GetCallerInfo", "SetCallerInfo", "SetMessageDialog"]),
    ...mapMutations(["setACWStatus"]),
    async GetCallerNumberCRM() {
      this.loading = true;
      try {
        const callerId = this.inCall
          ? this.currentCall?.SourceID
          : this.senderId;
        var resp = await this.GetCallerInfo(callerId);
        if (resp.success) {
          this.callerInfo = resp.info;
          this.hasCallerInfo = resp.errorcode == 0;
        } else {
          this.callerInfo = {};
          this.hasCallerInfo = false;
        }
      } catch (err) {
        let message = err.message;
        if (err.response) {
          message = err.response.data.message;
        }
        this.callerInfo = {};
        this.hasCallerInfo = false;
        this.SetMessageDialog({ show: true, message: message });
      } finally {
        this.loading = false;
      }
    },
    Create() {
      // console.log("My crm init", this.CRMInitInfo);
      // if (this.CRMInitInfo.has_info_create) {
      //   this.crmLocalFields?.forEach((localField) => {
      //     switch (localField.type) {
      //       case 1:
      //         this.callerInfo[localField.key] = "";
      //         break;
      //       case 2:
      //         this.callerInfo[localField.key] = "";
      //         break;
      //       case 3:
      //         this.callerInfo[localField.key] = "";
      //         break;
      //       case 4:
      //         this.callerInfo[localField.key] = "";
      //         break;
      //       case 5:
      //         this.callerInfo[localField.key] = [];
      //         break;
      //     }
      //   });
      //   this.inInfoMode = true;
      // } else {
      //   const url = this.CRMInitInfo.create_api.replace(
      //     "{CallerID}",
      //     this.caller || this.senderId
      //   );
      //   window.open(url, "_blank").focus();
      // }
    },
    async createNewCRM() {
      const validate = this.isValidCallerInfoFields();
      // console.log("My vallidate:", validate);
      if (!validate.valid) {
        this.errorMsg = validate.message;
        this.showSnackbar = true;
        // console.log(
        //   "My refst element",
        //   this.$refs[validate.key][0].$el.focus()
        // );
        this.$refs[validate.key][0].$el.focus();
        // this.$refs[validate.key].focused = true;
        // this.$refs[validate.key].focus();
        return;
      }

      this.createLocalLoading = true;
      try {
        var resp = await this.SetCallerInfo({
          customer: this.customer,
          info: JSON.stringify(this.callerInfo),
        });
        this.createLocalLoading = false;
        if (resp.success) {
          // this.callerInfo = resp.info;
          console.log("My resp after set caller", resp, resp.errorcode == 0);
          this.hasCallerInfo = true;
          this.inInfoMode = false;
          this.handleACWStatus();
        } else {
          this.SetMessageDialog({ show: true, message: resp.message });
        }
        // console.log("My values::", this.hasCallerInfo, this.callerInfo);
      } catch (err) {
        this.createLocalLoading = false;
        let message = err.message;
        if (err.response) {
          message = err.response.data.message;
        }
        this.SetMessageDialog({ show: true, message: message });
      }
    },
    handleACWStatus() {
      if (
        !this.acwSettings?.enabled ||
        !this.acwSettings?.skills?.includes(this.currentCall?.Dst) ||
        !this.acwSettings?.after_work?.includes(this.acwCRM)
      ) {
        return;
      }
      if (this.acwStatus) {
        this.setACWStatus({
          ...this.acwStatus,
          isSet: this.acwStatus.isSet.push(this.acwCRM),
        });
      } else {
        this.setACWStatus({
          channel: this.currentCall.Channel,
          isSet: [this.acwCRM],
        });
      }
    },
    View() {
      // if (this.CRMInitInfo.is_local) {
      //   //Create local set form
      // } else {
      //   const url = this.CRMInitInfo.display_api.replace(
      //     "{CallerID}",
      //     this.caller || this.senderId
      //   );
      //   window.open(url, "_blank").focus();
      // }
    },
    async Refresh() {
      try {
        await this.GetCallerNumberCRM();
      } catch (err) {
        let message = err.message;
        if (err.response) {
          message = err.response.data.message;
        }
        this.SetMessageDialog({ show: true, message: message });
      }
    },
    isValidCallerInfoFields() {
      // console.log("My validate callerInfo", this.callerInfo);
      for (const key in this.callerInfo) {
        const localField = this.crmLocalFields.find(
          (field) => field.key == key
        );
        // console.log("My local field:", localField);
        switch (localField.type) {
          case 1:
            // console.log("My type:", 1);
            if (localField.is_mandatory && this.callerInfo[key].trim() == "") {
              return {
                valid: false,
                message: this.$t("home.caller_info.mandatory_field_msg", {
                  field: localField.labels[this.currentLocal],
                }),
                // "field " +
                // localField.labels[this.currentLocal] +
                // " is mandatory",
                key,
              };
            }
            if (
              this.callerInfo[key].trim() != "" &&
              !isNaN(this.callerInfo[key])
            ) {
              return {
                valid: false,
                message:
                  // "field " +
                  // localField.labels[this.currentLocal] +
                  // " is invalid",
                  this.$t("home.caller_info.invalid_field_msg", {
                    field: localField.labels[this.currentLocal],
                  }),
                key,
              };
            }
            if (this.callerInfo[key].trim() == "") {
              this.callerInfo[key] = "-";
            } else {
              this.callerInfo[key] = this.callerInfo[key].trim();
            }
            break;
          case 2:
            // console.log("My type:", 2);
            if (localField.is_mandatory && this.callerInfo[key] == "") {
              return {
                valid: false,
                message: this.$t("home.caller_info.mandatory_field_msg", {
                  field: localField.labels[this.currentLocal],
                }),
                // "field " +
                // localField.labels[this.currentLocal] +
                // " is mandatory",
                key,
              };
            }
            if (this.callerInfo[key] != "" && isNaN(this.callerInfo[key])) {
              return {
                valid: false,
                message:
                  // "field " +
                  // localField.labels[this.currentLocal] +
                  // " is invalid",
                  this.$t("home.caller_info.invalid_field_msg", {
                    field: localField.labels[this.currentLocal],
                  }),
                key,
              };
            }
            if (!isNaN(this.callerInfo[key])) {
              this.callerInfo[key] = +this.callerInfo[key];
            } else if (this.this.callerInfo[key].trim() == "") {
              this.callerInfo[key] = "-";
            }
            break;
          case 3:
            // console.log(
            //   "My type:",
            //   3,
            //   localField.is_mandatory,
            //   this.callerInfo[key],
            //   typeof this.callerInfo[key]
            // );
            if (localField.is_mandatory && !this.callerInfo[key]) {
              return {
                valid: false,
                message: this.$t("home.caller_info.mandatory_field_msg", {
                  field: localField.labels[this.currentLocal],
                }),
                // "field " +
                // localField.labels[this.currentLocal] +
                // " is mandatory",
              };
            }
            if (
              !!this.callerInfo[key] &&
              !moment(this.callerInfo[key]).isValid()
            ) {
              return {
                valid: false,
                message:
                  // "field " +
                  // localField.labels[this.currentLocal] +
                  // " is invalid",
                  this.$t("home.caller_info.invalid_field_msg", {
                    field: localField.labels[this.currentLocal],
                  }),
                key,
              };
            }
            // console.log(
            //   "My caller info 3",
            //   this.callerInfo[key],
            //   typeof this.callerInfo[key]
            // );
            if (
              typeof this.callerInfo[key] == "string" &&
              this.callerInfo[key].trim() == ""
            ) {
              this.callerInfo[key] = "-";
            } else if (
              this.callerInfo[key] != null &&
              this.callerInfo[key] != ""
            ) {
              this.callerInfo[key] = moment(this.callerInfo[key])
                .format("YYYY-MM-DD HH:mm:ss")
                .toString();
            }
            break;
          case 4:
            // console.log("My type:", 4);
            if (localField.is_mandatory && this.callerInfo[key].trim() == "") {
              return {
                valid: false,
                message: this.$t("home.caller_info.mandatory_field_msg", {
                  field: localField.labels[this.currentLocal],
                }),
                // "field " +
                // localField.labels[this.currentLocal] +
                // " is mandatory",
                key,
              };
            }
            if (this.callerInfo[key].trim() == "") {
              this.callerInfo[key] = "-";
            } else {
              this.callerInfo[key] = this.callerInfo[key].trim();
            }
            break;
          case 5:
            console.log("My type:", 5);
            if (localField.is_mandatory && this.callerInfo[key].length == 0) {
              return {
                valid: false,
                message: this.$t("home.caller_info.mandatory_field_msg", {
                  field: localField.labels[this.currentLocal],
                }),
                // "field " +
                // localField.labels[this.currentLocal] +
                // " is mandatory",
                key,
              };
            }
            if (this.callerInfo[key].includes("")) {
              return {
                valid: false,
                message: this.$t("home.caller_info.invalid_field_msg", {
                  field: localField.labels[this.currentLocal],
                }),
                // "field " +
                // localField.labels[this.currentLocal] +
                // " is mandatory",
                key,
              };
            }
            break;
        }
      }
      return { valid: true, message: "" };
    },
    setInfoOutput(key) {
      if (!this.callerInfo[key]) {
        return "";
      }
      if (Array.isArray(this.callerInfo[key])) {
        return this.callerInfo[key].join();
      }
      return this.callerInfo[key];
    },
    setInfoKey(key) {
      if (this.CRMInitInfo?.is_local || this.CRMInitInfo?.has_info_create) {
        const localField = this.crmLocalFields?.find(
          (field) => field.key == key
        );
        return localField ? localField.labels[this.currentLocal] : key;
      } else {
        return key;
      }
    },
  },
  async mounted() {
    if ((this.currentCall && this.currentCall?.SourceID) || this.senderId) {
      // if (this.caller.includes("012345678")) {
      //   this.hasCallerInfo = true;
      // }
      await this.GetCallerNumberCRM();
    }
  },
  watch: {
    async currentCall(val) {
      if (val) {
        await this.GetCallerNumberCRM();
        this.customer = val.SourceID;
      }
    },
    senderId(val) {
      if (val && !this.inCall) {
        this.GetCallerNumberCRM();
      }
    },
    inInfoMode(value) {
      this.$emit("infoMode", value);
    },
  },
};
</script>
<style scoped>
.set-border {
  border: 2px solid #d7eaf3;
}
</style>
